import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  providers: null,
  casinoCategoriesList: null,
  categoryWiseGamesList: [],
  favouriteGamesList: [],
  favouriteGames: null,
  allFavouriteGames: null,
  usersCasinoTransactions: null,
  viewAllGames: null,
  showAllFavGames: false,
  customFavourites: {},
  customGameTransactions: {},
  filteredGames: null
}

const {
  actions: {
    setFavouriteGame,
    setShowAllFavGames,
    setGamesList,
    setViewAllGames,
    setCustomFavGames,
    setCustomGameTransactions,
    setFilteredGames,
    setCasinoFavoriteGamesList,
    setViewAllFavouriteGames
  },
  reducer
} = createSlice({
  name: 'games',
  initialState,
  reducers: {
    setFilteredGames: (state, action) => ({
      ...state,
      filteredGames: action.payload
    }),
    setCustomGameTransactions: (state, action) => ({
      ...state,
      customGameTransactions: action.payload
    }),
    setFavouriteGame: (state, action) => ({
      ...state,
      favouriteGames: action.payload
    }),
    setShowAllFavGames: (state, action) => ({
      ...state,
      showAllFavGames: action.payload
    }),
    setGamesList: (state, action) => ({
      ...state,
      categoryWiseGamesList: action?.payload
    }),
    setViewAllGames: (state, action) => ({
      ...state,
      viewAllGames: action?.payload
    }),
    setCustomFavGames: (state, action) => ({
      ...state,
      customFavourites: action?.payload
    }),
    setCasinoFavoriteGamesList: (state, action) => ({
      ...state,
      favouriteGamesList: action.payload
    }),
    setViewAllFavouriteGames: (state, action) => ({
      ...state,
      allFavouriteGames: action?.payload
    })
  }
})

export {
  setFavouriteGame,
  setShowAllFavGames,
  setGamesList,
  setViewAllGames,
  setCustomFavGames,
  setCustomGameTransactions,
  setFilteredGames,
  setCasinoFavoriteGamesList,
  setViewAllFavouriteGames
}

export default reducer
